export default "__VITE_ASSET__31979a42__"